module.exports = __webpack_public_path__ + "static/media/Satzung.cd4d0c90.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/Satzung.pdf
// module id = 98
// module chunks = 0